import { render, staticRenderFns } from "./CellRendererStatus.vue?vue&type=template&id=2a49b8fc&"
import script from "./CellRendererStatus.vue?vue&type=script&lang=js&"
export * from "./CellRendererStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports